import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';


@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageElearningService {

  constructor(private service: PHBHPApiService) { }


  getTutorials() {
    return this.service.getApi('Tutorials/GetTutorials', true);
  }
  getSOPDetails(userId){
    return this.service.getApi(`ManageSOPPuzzle/GetSOPPuzzleList/${userId}`,true);
  }
  getPuzzlesbyActiveInstitution(userId,activeInstitutionID){
    return this.service.getApi(`ManageSOPPuzzle/GetPuzzlesbyActiveInstitution/${userId}/${activeInstitutionID}`,true);
  }
  getSOPById(Id){
    return this.service.getApi('SOPs/GetSOPById/'+Id,true);
  }
  getbestScoreDetails(sopId){
    return this.service.getApi(`SOPPuzzles/SOPPuzzleBestScore/${sopId}`,true);
  }
  savebestScoreDetails(data){
    return this.service.postApi(`SOPPuzzles/CreateSOPPuzzle`,data,true);
  }

}

